import { IStoreState } from '../state/store';
import { ILoadAlbum } from '../state/actions/albumAction';

export const getLoadAlbumState = ({
  loadAlbumState,
}: IStoreState): ILoadAlbum => loadAlbumState;
